import React from 'react';
import moment from 'moment';

import { Section } from '../..';
import { defaultPropTypes } from '../AdditionalData';
import { checkSectionCondition } from '../../../Form.helpers';

const Birthday = ({ field, translations }) => {
    const getVal = () => {
        if (field.value) {
            return moment(field.value).format('DD.MM.YYYY');
        }
        return null;
    };
    const renderedSection = checkSectionCondition(getVal());

    return (
        <Section.Conditional
            condition={Boolean(field.order) && renderedSection}
            title={translations.age}
        >
            {({ renderField }) => (
                renderField(translations.birthday, getVal())
            )}
        </Section.Conditional>
    );
};
Birthday.propTypes = defaultPropTypes;

export default Birthday;